/*
 * @Author: Teemo Ding
 * @Date: 2021-11-30 14:20:23
 * @LastEditTime: 2022-01-04 10:59:24
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/BillingAddress/index.tsx
 */
import { ModalFooter, Select } from '@/src/components/Antd';
import { AddressFieldType } from '@/src/types/common/common';
import { useRequest } from 'ahooks';
import { Form } from 'antd';
import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { getLocation } from 'src/request/order';
import { onFinishFailed } from 'src/tools/helper';
import { responseHandler } from 'src/tools/server';
import { i18nGet } from 'src/tools/tools';
import { modal } from 'src/utils/Modal';
import AddressFields from '../AddressFields';
import css from './css.module.less';
const formName = 'billingAddress';
const BillingAddress = ({
  destinations,
  countries,
  onCancel,
  orderUuid,
  consignee,
  reLoadOrderPage,
  languageCode,
  onConfirm,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const [form] = Form.useForm();
  const [provinces, setProvinces] = useState([]);
  const [formatFields, setFormatFields] = useState([]);

  const { run: _getLocation } = useRequest(
    (countryCode, locale) => getLocation(countryCode, locale),
    {
      manual: true,
      onSuccess: (res) => {
        setProvinces(countryLocationsFormat(res));
      },
    },
  );
  const countriesAll = (destinations || []).reduce((pre, now) => {
    return pre.concat(now.country);
  }, []);
  const countryOption = (countriesAll || []).map((item) => ({
    label: item.name,
    value: get(item, 'code', ''),
  }));

  const countryLocationsFormat = (children) => {
    const countryLocationsOptions = {} as any;
    countryLocationsOptions.label = get(children, 'location.name');
    countryLocationsOptions.uuid = get(children, 'location.uuid');
    countryLocationsOptions.code = get(children, 'location.code');
    if (get(children, 'subsets')) {
      countryLocationsOptions.children = children.subsets.map((item) =>
        countryLocationsFormat(item),
      );
    } else {
      countryLocationsOptions.children = [];
    }
    return countryLocationsOptions;
  };
  /**Country变化时调用 */
  const changeCountry = (countryCode) => {
    const destinationsIndex = (destinations || []).filter(
      (o) => o.country.code === countryCode,
    );
    if (countryCode && languageCode) _getLocation(countryCode, languageCode);
    if (destinationsIndex.length) {
      setFormatFields(destinationsIndex[0].format.fields);
      form.setFieldsValue({ [AddressFieldType.Subdivision]: [] });
    }
  };

  useEffect(() => {
    const initValue = {
      country: get(consignee, 'countryVO.code'),
      [AddressFieldType.AddressLine1]: get(consignee, 'address'),
      [AddressFieldType.AddressLine2]: get(consignee, 'address2'),
      [AddressFieldType.City]: get(consignee, 'city'),
      [AddressFieldType.Subdivision]: [
        ...(get(consignee, 'countryVO.uuid') ? [consignee.countryVO] : []),
        ...(get(consignee, 'provinceVO.uuid') ? [consignee.provinceVO] : []),
        ...(get(consignee, 'cityVO.uuid') ? [consignee.cityVO] : []),
        ...(get(consignee, 'countyVO.uuid') ? consignee.countyVO : []),
      ],
      [AddressFieldType.Postcode]: get(consignee, 'postalCode'),
    };
    if (get(consignee, 'countryVO.code')) {
      changeCountry(get(consignee, 'countryVO.code'));
    }
    form.setFieldsValue(initValue);
  }, []);
  const onFinish = (values) => {
    const { AddressLine1, AddressLine2, City, Subdivision, Postcode } = values;
    const consignee = {
      countryVO: {
        uuid: Subdivision[0].uuid,
        name: Subdivision[0].label,
        code: (Subdivision[0] || {}).code,
      },
      address: AddressLine1,
      address2: AddressLine2,
      city: City,
      cityVO: {
        uuid: (Subdivision[2] || {}).uuid,
        name: (Subdivision[2] || {}).label,
        code: (Subdivision[3] || {}).code,
      },
      provinceVO: {
        uuid: (Subdivision[1] || {}).uuid,
        name: (Subdivision[1] || {}).label,
        code: (Subdivision[3] || {}).code,
      },
      countyVO: {
        uuid: (Subdivision[3] || {}).uuid,
        name: (Subdivision[3] || {}).label,
        code: (Subdivision[3] || {}).code,
      },
      postalCode: Postcode,
    };
    if (onConfirm) {
      onConfirm(consignee).then((res) => {
        //console.log('res', res);
        const { response, cb } = res || {};
        const _response = responseHandler(response);
        const { success, data, errMsg } = _response;
        if (success) {
          if (cb) {
            cb(data);
          }
          return;
        } else {
          modal.error({
            title: getI18n('general.tools_server.requestError'),
            content:
              errMsg ||
              getI18n(
                'allOrders.createneworder.component_customer_BillingAddress_error',
              ),
            onCancel: () => {
              console.error(
                errMsg ||
                  getI18n(
                    'allOrders.createneworder.component_customer_BillingAddress_error',
                  ),
              );
            },
            onCancelText: getI18n('general.antd.Uploader.ok'),
          });
          return;
        }
      });
    }
  };
  const onValuesChange = (changedValues) => {
    if (Object.keys(changedValues).includes('country')) {
      changeCountry(changedValues['country']);
    }
  };
  return (
    <div>
      <Form
        form={form}
        name={formName}
        className={css.billingAddress}
        onValuesChange={onValuesChange}
        onFinishFailed={(error) => {
          onFinishFailed(formName, error);
        }}
        onFinish={onFinish}>
        <h3>{getI18n('general.billingAddress')}</h3>
        <Form.Item
          name='country'
          label={`${getI18n('allOrders.orderDetail.countryRegion')}*`}
          rules={[
            {
              required: true,
              message: getI18n(
                'allOrders.createneworder.component_customer_BillingAddress_countrymsg',
              ),
            },
          ]}
          labelCol={{ span: 24 }}>
          <Select size='large' options={countryOption} />
        </Form.Item>
        <AddressFields provinces={[provinces]} fields={formatFields} />
      </Form>
      <ModalFooter
        onOk={() => form.submit()}
        onCancel={() => onCancel()}
        okText={getI18n('general.confirm')}
      />
    </div>
  );
};

export default BillingAddress;
